<template>
  <div>
    <div class="container">
      <lease-options-table
        v-if="loaded"
        :term="false"
        :costs="costs"
        :current_costs="current_costs"
      ></lease-options-table>
      <lease-options-table
        v-if="loaded"
        :term="0"
        :costs="costs"
        :current_costs="current_costs"
      ></lease-options-table>
      <lease-options-table
        v-if="loaded"
        :term="1"
        :costs="costs"
        :current_costs="current_costs"
      ></lease-options-table>
      <lease-options-table
        v-if="loaded"
        :term="2"
        :costs="costs"
        :current_costs="current_costs"
      ></lease-options-table>
      <lease-options-table
        v-if="loaded"
        :term="3"
        :costs="costs"
        :current_costs="current_costs"
      ></lease-options-table>
      <lease-options-table
        v-if="loaded"
        :term="4"
        :costs="costs"
        :current_costs="current_costs"
      ></lease-options-table>
      <lease-options-table
        v-if="loaded"
        :term="5"
        :costs="costs"
        :current_costs="current_costs"
      ></lease-options-table>
    </div>
  </div>
</template>
<script>
  import LeaseOptionsTable from './Partials/LeaseOptionsTable.vue'

  export default {
    components: {
      LeaseOptionsTable,
    },
    created() {
      this.quote_id = this.$route.params.id
      this.load()
    },
    data() {
      return {
        loaded: false,
        quote_id: null,
        costs: null,
        current_costs: null,
      }
    },
    methods: {
      load() {
        this.axios.get('quotes/results/' + this.quote_id).then(response => {
          this.costs = response.data.results.new_costs
          this.current_costs = response.data.results.current_costs

          this.loaded = true
        })
      }
    }
  }
</script>
<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/views/ProposalTemplate/Calculations.vue